import Pusher from "pusher-js";

const DEFAULT_KEY = "dvmwxqcfjfddtolftxva";
const DEFAULT_HOST = "127.0.0.1";
const DEFAULT_PORT = 6001;

/**
 * Mirrors Flutter ChatMessageController.startListingPusher():
 * subscribe to message.sent.{userId} and message.receive.{userId}, bind support.chatting,
 * pass CHAT_ID to callback so caller can fetch full row via get-a-message.
 *
 * @param {string|number} userId
 * @param {(chatId: string) => void} onChatId
 * @returns {() => void} unsubscribe
 */
export function attachSupportChatPusher(userId, onChatId) {
  if (userId == null || userId === "") return () => {};
  const uid = String(userId);
  if (typeof onChatId !== "function") return () => {};

  const key = process.env.REACT_APP_PUSHER_KEY || DEFAULT_KEY;
  const host = process.env.REACT_APP_PUSHER_HOST || DEFAULT_HOST;
  const port = Number(process.env.REACT_APP_PUSHER_PORT || DEFAULT_PORT, 10) || DEFAULT_PORT;
  const forceTLS = process.env.REACT_APP_PUSHER_FORCE_TLS !== "false";

  const pusher = new Pusher(key, {
    cluster: "mt1",
    wsHost: host,
    wsPort: port,
    wssPort: port,
    forceTLS,
    enabledTransports: ["ws", "wss"],
    disableStats: true,
  });

  const ch1 = pusher.subscribe(`message.sent.${uid}`);
  const ch2 = pusher.subscribe(`message.receive.${uid}`);

  const handler = (payload) => {
    try {
      const data = typeof payload === "string" ? JSON.parse(payload) : payload;
      const chatId = data?.CHAT_ID ?? data?.chat_id ?? data?.CHAT_id;
      if (chatId != null && chatId !== "") onChatId(String(chatId));
    } catch (_) {}
  };

  ch1.bind("support.chatting", handler);
  ch2.bind("support.chatting", handler);

  return () => {
    try {
      ch1.unbind("support.chatting", handler);
      ch2.unbind("support.chatting", handler);
      pusher.unsubscribe(`message.sent.${uid}`);
      pusher.unsubscribe(`message.receive.${uid}`);
      pusher.disconnect();
    } catch (_) {}
  };
}
